module.exports = __webpack_public_path__ + "static/media/call_attendant_sound.1065fe97.mp3";